var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4283 5.61223C3.65415 4.57116 4.54877 3.80029 5.61603 3.80029H10.3843C11.4515 3.80029 12.3462 4.57116 12.572 5.61223L13.8783 11.6337C14.1855 13.0496 13.1617 14.4627 11.6906 14.4627H4.30973C2.83864 14.4627 1.81483 13.0496 2.12199 11.6337L3.4283 5.61223ZM5.61603 5.00029C5.1498 5.00029 4.71502 5.34114 4.60102 5.86664L3.29471 11.8882C3.13477 12.6254 3.67313 13.2627 4.30973 13.2627H11.6906C12.3272 13.2627 12.8655 12.6254 12.7056 11.8882L11.3993 5.86664C11.2853 5.34114 10.8505 5.00029 10.3843 5.00029H5.61603Z",
    fill: "#059669"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9803 3.80013H9.01983C8.95693 3.43193 8.83782 3.17622 8.70628 3.00834C8.52356 2.77512 8.28441 2.6668 8.00007 2.6668C7.71572 2.6668 7.47657 2.77512 7.29385 3.00834C7.16231 3.17622 7.0432 3.43193 6.9803 3.80013ZM6.34926 2.26823C6.76975 1.73157 7.36394 1.4668 8.00007 1.4668C8.63619 1.4668 9.23038 1.73157 9.65087 2.26823C10.0604 2.79089 10.2667 3.51987 10.2667 4.40013V5.00013H5.7334V4.40013C5.7334 3.51987 5.93975 2.79089 6.34926 2.26823Z",
    fill: "#059669"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76774 10.8402L8.65836 10.816V7.81427H9.1912L9.19186 7.82783C9.20586 8.11565 9.4433 8.34183 9.73147 8.34183C10.0298 8.34183 10.2717 8.09995 10.2717 7.80158V7.34087C10.2717 6.98709 9.98492 6.70029 9.63114 6.70029H6.37261C6.01883 6.70029 5.73203 6.98709 5.73203 7.34087V7.80522C5.73203 8.10158 5.97228 8.34183 6.26864 8.34183C6.5536 8.34183 6.78887 8.11908 6.80444 7.83454L6.80555 7.81427H7.33255V10.816L7.22317 10.8402C7.0023 10.8889 6.84502 11.0846 6.84502 11.3108C6.84502 11.577 7.06079 11.7928 7.32697 11.7928H8.66394C8.93012 11.7928 9.1459 11.577 9.1459 11.3108C9.1459 11.0846 8.98861 10.8889 8.76774 10.8402Z",
    fill: "#059669",
    stroke: "transparent",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlIcon);
export default __webpack_public_path__ + "static/media/controlIcon.f2415074.svg";
export { ForwardRef as ReactComponent };